// extracted by mini-css-extract-plugin
module.exports = {"root":"ContactLandownerButton_root__1zHgL","contactButton":"ContactLandownerButton_contactButton__3La4B"};